export default __webpack_public_path__ + "static/media/testimonial-3.8bc41f8a.jpg";